import LegalLayout from "./LegalLayout";

export default function DataDeletion() {
    return (
        <LegalLayout
            title="Data Deletion"
            lastUpdated="October 20, 2026"
            testId="page-data-deletion"
            seoTitle="Data Deletion | TRT Plus"
            seoDescription="How to delete your TRT Plus data. Everything is stored on your device, so you can delete it yourself on iPhone or Android."
            seoPath="/data-deletion"
        >
            <h2>Delete your data</h2>
            <p>
                All your TRT Plus data is stored on your device, so you can
                delete it yourself.
            </p>
            <ul>
                <li>
                    <strong>iPhone:</strong> Settings › General › iPhone
                    Storage › TRT Plus › Delete App. "Offload App" keeps
                    your data.
                </li>
                <li>
                    <strong>Android:</strong> Settings › Apps › TRT Plus ›
                    Storage › Clear Storage, or uninstall the app.
                </li>
            </ul>

            <h2>Also delete separately</h2>
            <ul>
                <li>
                    Backup files you exported. Delete them from Files,
                    Drive, email or wherever you saved them.
                </li>
                <li>
                    Apple Health access: iOS Settings › Health › Data Access
                    &amp; Devices › TRT Plus. Deleting the app does not
                    delete the data held in Apple Health itself.
                </li>
                <li>
                    Anything you shared with an AI app through Discuss with
                    your AI or Share Report. Delete it in that app.
                </li>
            </ul>

            <h2>AI services</h2>
            <p>
                OpenAI and xAI may keep data you sent for up to about 30
                days, then delete it automatically.
            </p>

            <h2>Purchases</h2>
            <p>
                Purchase records are kept by Apple, Google and RevenueCat to
                manage your purchases.
            </p>
        </LegalLayout>
    );
}
